import { assocPath, isNil, path } from 'ramda';
import { IOfferState } from '../../redux/reducers';
import { TDynamicPricingAttributes } from '../../types/dynamicPricing';

interface IParams {
  offer: IOfferState;
  dynamicPricingAttributes: TDynamicPricingAttributes;
}

export const getDynamicPricingParameters = (params: IParams): object => {
  const { offer, dynamicPricingAttributes } = params;

  return dynamicPricingAttributes.reduce((stash, keyPath) => {
    const value = path(keyPath, offer);

    if (isNil(value)) {
      return stash;
    } else {
      return assocPath(keyPath, value, stash);
    }
  }, {});
};
